import { render, staticRenderFns } from "./CollapsedOrdersBar.vue?vue&type=template&id=e6e1f544&scoped=true&"
import script from "./CollapsedOrdersBar.vue?vue&type=script&lang=js&"
export * from "./CollapsedOrdersBar.vue?vue&type=script&lang=js&"
import style0 from "./CollapsedOrdersBar.vue?vue&type=style&index=0&id=e6e1f544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e1f544",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
